<script lang="ts" setup>
import FooterAppMarketplaces from '~/components/footer/FooterAppMarketplaces.vue'
import FooterBottom from '~/components/footer/FooterBottom.vue'
import FooterSocialNetworks from '~/components/footer/FooterSocialNetworks.vue'
import FooterTop from '~/components/footer/FooterTop.vue'
</script>

<template>
  <footer class="bg-white">
    <div class="mx-auto px-2 pb-[50px] pt-8 md:px-4 md:pb-0 md:pt-[60px] xl:max-w-[1440px] xl:px-10">
      <FooterTop />
      <FooterSocialNetworks />
      <FooterAppMarketplaces />
      <FooterBottom />
    </div>
  </footer>
</template>
